import React from "react";
import PageLoader from "../common/pageLoader/PageLoader";
import moment from "moment";
function HistoryTable(props) {
  return (
    <div>
      {props.isLoading ? (
        <PageLoader />
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full bg-white shadow-lg rounded-sm border border-[#81a3b8]">
            {/* Table header */}
              <thead className="table-bg text-xs font-semibold capitalize text-[#757575] border-[#81a3b8]">
                <tr>
                  <th
                    className="px-2 py-3 first:pl-8 last:pr-5 tbl-th whitespace-nowrap text-white text-left"
                    colSpan={5} 
                  >
                    <div className="font-bold tble-th-txt">History</div>
                  </th>
                </tr>
              </thead>

            {/* Table body */}
            {props.isCorporate ? (
              <tbody className="text-sm custom-tbody border border-[#757575]">
                {props.engagementList.map((engagement, key) => (
                  <tr key={key} className="bg-[#f5f5f5] border-b border-[#757575]">
                    <td className="p-8 text-lg w-full bg-[#f5f5f5]" colSpan={3}>
                      <div className="flex justify-between gap-4 items-start w-full bg-[#f5f5f5]">
                        <div className="flex-1 text-[#3a4358] space-y-3">
                          {/* Engagement Type */}
                          <div>
                            <span className="font-semibold">Engagement Type: </span>
                            <span>{engagement.engagementType}</span>
                          </div>
                          {/* Engagement Date */}
                          <div>
                            <span className="font-semibold">Engagement Date: </span>
                            <span>{moment(engagement.engagementDate).format("DD/MM/YYYY")}</span>
                          </div>
                          {/* Follow Up */}
                          <div>
                            <span className="font-semibold">Follow Up: </span>
                            <span className="font-bold">{engagement.followUp || "-"}</span>
                          </div>
                          {/* Description */}
                          <div>
                            <span className="font-semibold">Description: </span>
                            <div
                              className="mt-1 ck-content"
                              dangerouslySetInnerHTML={{
                                __html: engagement.engagementDescription || "",
                              }}
                            />
                          </div>
                        </div>

                        <div className="flex items-start justify-end w-32 text-right bg-[#f5f5f5]">
                          <div
                            className="font-bold text-[#c00000] cursor-pointer hover:text-[#a00000]"
                            onClick={() =>
                              props.onEdit(engagement.corporateEngagementTrackingId)
                            }
                          >
                            View/Edit
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody className="text-sm custom-tbody border border-[#757575]">
                {props.engagementList.map((engagement, key) => (
                  <tr key={key} className="bg-[#f5f5f5] border-b border-[#757575]">
                    <td className="p-8 text-lg w-full bg-[#f5f5f5]" colSpan={5}>
                      <div className="flex justify-between gap-4 items-start w-full bg-[#f5f5f5]">
                        <div className="flex-1 text-[#3a4358] space-y-3">
                          {/* Engagement Type */}
                          <div>
                            <span className="font-semibold">Engagement Type: </span>
                            <span>{engagement.corporateEngagementTypeName}</span>
                          </div>
                          {/* Engagement Date */}
                          <div>
                            <span className="font-semibold">Engagement Date: </span>
                            <span>{moment(engagement.engagementDate).format("DD/MM/YYYY")}</span>
                          </div>
                          {/* Follow Up */}
                          <div>
                            <span className="font-semibold">Follow Up: </span>
                            <span className="font-bold">
                              {engagement.corporateEngagementFollowUpByName || "-"}
                            </span>
                          </div>
                          {/* Description */}
                          <div>
                            <span className="font-semibold">Description: </span>
                            <div
                              className="mt-1 ck-content"
                              dangerouslySetInnerHTML={{
                                __html: engagement.engagementDescription || "",
                              }}
                            />
                          </div>
                        </div>
                        <div className="flex items-start justify-end w-32 text-right bg-[#f5f5f5]">
                          <div
                            className="font-bold text-[#c00000] cursor-pointer hover:text-[#a00000]"
                            onClick={() =>
                              props.onEdit(engagement.individualEngagementId)
                            }
                          >
                            View/Edit
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}

          </table>
        </div>
      )}
    </div>
  );
}
export default HistoryTable;